import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { CourseStatusEnum } from '@edtech-ui/constants/course-status.enum';
import { CompleteSyllabusResponseAI } from '@edtech-ui/core/models/ai-course/ai-complete-syllabus';
import { SyllabusResponseAI } from '@edtech-ui/core/models/ai-course/ai-generate-syllabus';
import { UpdateCourseDataAI } from '@edtech-ui/core/models/ai-course/edit-course';
import { ManualCourse } from '@edtech-ui/core/models/manual-course/manual-couse-payload';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';
import { noFutureYearValidator } from '@edtech-ui/core/utils/noFutureYearValidator';
import { UnpublishedCourseDialogBoxComponent } from '@edtech-ui/dashboard/teacher/classroom/create-course/unpublished-course-dialog-box/unpublished-course-dialog-box.component';
import { DeleteDialogBoxComponent } from '@edtech-ui/dashboard/teacher/classroom/delete-dialog-box/delete-dialog-box.component';
import { QuillModule } from 'ngx-quill';
import { ToastrService } from 'ngx-toastr';
import { catchError, filter, finalize, forkJoin, of, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-admin-course-review',
  standalone: true,
  imports: [CommonModule, FormsModule,CommonModule, MatIcon, ReactiveFormsModule, QuillModule,HasPermissionDirective],
  templateUrl: './admin-course-review.component.html',
  styleUrl: './admin-course-review.component.scss'
})
export class AdminCourseReviewComponent {
  classroomId: any = '';
  courseId: string = '';
  coursePayload: ManualCourse = {
    course_code: '',
    course_title: '',
    grade_level: '',
    credits: 0,
    course_description: '',
    course_duration: 0,
    internal_marks: 0,
    exam_marks: 0,
    total_units_count: 0,
    course_objectives: [],
    course_outcomes: [],
    units: [],
    textbooks: [],
    web_references_links: [],
    status: 'Draft'
  };
  isLoadingDraft = false;
  isLoadingPublish = false;
  private subscription: Subscription = new Subscription();
  isPublish: boolean = false;
  _syllabusData: SyllabusResponseAI['Data'] | null = null;
  status: CourseStatusEnum | null = null;
  classroomid!: number;
  courseStatus = CourseStatusEnum;
  isPageLoading = true;
  isEditing: boolean = false;
  isEditingTextbooks: boolean = false;
  isEditingWebResources: boolean = false;
  isEditingCourseDocument: boolean = false;
  textbooksForm!: FormGroup;
  webResourcesForm!: FormGroup;
  documentForm!: FormGroup;
  documentFileName: string | null = null;
  selectedDocumentFile: File | null = null;
  isEditingObjectives: boolean = false;
  editCourseForm!: FormGroup;
  isEditingUnits = false;
  unitsForm!: FormGroup;
  canSaveUnits = false;
  isEditingOutcomes: boolean = false;
  outcomesForm!: FormGroup;
  isDragging = false;
  selectedThumbnailFile: File | null = null;
  previewThumbnail: string | null = null;
  removeExistingThumbnailFlag = false;
  removeExistingDocumentFlag = false;
  PermissionForStudents = PermissionForStudents;

  constructor(
    private courseService: CourseManagementService,
    private _toast: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private _courseService: CourseManagementService,
    private _toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  // ngOnInit(): void {
  //   this.route.parent?.paramMap.subscribe(params => {
  //     this.classroomId = params.get('classroomId') ?? '';
  //   });
  //   this.route.queryParamMap.subscribe(params => {
  //     const courseId = params.get('courseId');
  //     if (courseId) {
  //       this.courseId = courseId;
  //       this.loadCourseData();
  //     }
  //   });
  //   this.subscription.add(
  //     this.courseService.payloadChanges().subscribe(payload => {
  //       if (!this.courseId && payload) {
  //         this.coursePayload = payload;
  //       }
  //     })
  //   );
  //   this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
  //     if (!e.url.includes('/manual-course-creation')) {
  //       this.courseService.clearPayload();
  //     }
  //   });
  // }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.classroomId = params.get('classroomId') ?? '';
      this.courseId = params.get('courseId') ?? '';

      console.log('Resolved courseId:', this.courseId);

      if (!this.courseId) {
        this._toast.error('Course ID not found');
        return;
      }

      this.loadCourseData();
    });
  }

  loadCourseData() {
    this.isPageLoading = true;

    this.subscription.add(
      this.courseService.getCoursesByCourseId(this.courseId)
        .pipe(
          tap((response) => {
            if (response?.Success && response.Data) {
              this.coursePayload = response.Data as any;
              this.status = response.Data.status as CourseStatusEnum;
              this.initSectionForms();
              this.initUnitsForm();

            }
            this.isPageLoading = false;
          }),
          catchError(() => {
            this.isPageLoading = false;
            this._toast.error('Error fetching course');
            return of(null);
          })
        )
        .subscribe()
    );
  }


  saveAsDraft(): void {
    this.postManualCourse(this.coursePayload, CourseStatusEnum.Draft);
    // this.router.navigate(['/admin-student-platform/admin-courses']);
  }

  publishCourse(): void {
    this.postManualCourse(this.coursePayload, CourseStatusEnum.Published);
    // this.router.navigate(['/admin-student-platform/admin-courses']);
  }

  postManualCourse(payload: ManualCourse, status: CourseStatusEnum): void {
    if (!this.classroomId) {
      this._toast.error('Classroom ID is required');
      return;
    }
    status === CourseStatusEnum.Draft ? this.isLoadingDraft = true : this.isLoadingPublish = true;

    const preparedPayload: ManualCourse = {
      ...payload,
      credits: Number(payload.credits || 0),
      internal_marks: Number(payload.internal_marks || 0),
      exam_marks: Number(payload.exam_marks || 0),
      course_duration: Number(payload.course_duration || 0),
      total_units_count: payload.units?.length || 0,
      status: status === CourseStatusEnum.Draft ? 'Draft' : 'Published',
      units: (payload.units || []).map((unit, unitIndex) => ({
        // unit_id: unit.unit_id || '',
        unit_title: String(unit.unit_title || ''),
        unit_hours: Number(unit.unit_hours || 0),
        order: unitIndex + 1,
        topics: (unit.topics || []).map((topic, topicIndex) => ({
          topic_title: String(topic.topic_title || ''),
          order: topicIndex + 1,
          subtopics: (topic.subtopics || []).map(sub => ({
            subtopic_title: sub.subtopic_title || '',
            description: sub.description || '',
            reference_links: sub.reference_links || []
          }))
        }))

      })),

      web_references_links: (payload.web_references_links || []).map(link => typeof link === 'string' ? link : '')
    };

    let request$;
    if (this.courseId) {
      request$ = this.courseService.patchPublishedCourseByStatus(this.classroomId, this.courseId);
    } else {
      request$ = this.courseService.saveCourse(preparedPayload);
    }

    request$.pipe(
      tap((response: any) => {
        this.isLoadingDraft = false;
        this.isLoadingPublish = false;

        if (response?.Success) {
          this._toast.success(status === CourseStatusEnum.Draft
            ? 'Course saved as draft successfully!'
            : 'Course published successfully!');
          this.courseService.clearPayload();
          if (status === CourseStatusEnum.Published) {
            this.router.navigate(['/admin-student-platform/admin-courses']);
          } else {
            if (status === CourseStatusEnum.Draft) {
              this.router.navigate(['/admin-student-platform/admin-courses']);
            }
          }
        } else {
          this._toast.error(response?.Message || 'Failed to save course');
        }
      }),
      catchError(() => {
        this.isLoadingDraft = false;
        this.isLoadingPublish = false;
        this._toast.error('Something went wrong while saving the course');
        return of(null);
      })
    ).subscribe();
  }

  getCourseDetailsById() {
    if (this.courseId && this.classroomId) {
      this.subscription.add(
        this.courseService.getCoursesByCourseId(this.courseId).subscribe({
          next: (response: CompleteSyllabusResponseAI) => {
            if (response.Success && response.Data) {
              this._syllabusData = response.Data;
              this.status = response.Data.status as CourseStatusEnum;
            }
          }
        })
      );
    }
  }

  openDeleteCourseDialogBox(courseId: string) {
    this.dialog.open(DeleteDialogBoxComponent, {
      width: '360px',
      data: { courseId }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.deleteCoursesById(courseId)
      }
    });
  }

  deleteCoursesById(courseId: string) {
    this.subscription.add(
      this.courseService.deleteCourseById(courseId).subscribe({
        next: () => {
          this._toast.success('Course deleted successfully');
          this.router.navigate(['/teacher-dashboard/classroom-detail-page', this.classroomId, 'courses']);
        },
        error: () => {
          this._toast.error('Failed to delete course');
        }
      })
    );
  }

  openUnpublishDialogBox() {
    this.dialog.open(UnpublishedCourseDialogBoxComponent, {
      width: '400px',
      data: { courseId: this.courseId }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.patchPublishedCourseByStatus()
      }
    });
  }

  patchPublishedCourseByStatus() {
    if (!this.classroomId) {
      this._toast.error('Classroom ID is required');
      return;
    }
    this.isPublish = true;
    this.subscription.add(
      this.courseService.patchPublishedCourseByStatus(this.classroomId, this.courseId).pipe(
        tap(response => {
          if (response.Success) {
            this.getCourseDetailsById();
            const courseStatus = response.Data?.status;
            if (courseStatus === CourseStatusEnum.Published) {
              this._toast.success('Your course has been published and is now available to students');
              this.router.navigate(['/teacher-dashboard/classroom-detail-page', this.classroomId, 'courses']);
            } else if (courseStatus === CourseStatusEnum.Draft) {
              this._toast.success('Your course was Published and is now moved to Draft.');
            }
          } else {
            this._toast.error(response.Message);
          }
        }),
        finalize(() => {
          this.isPublish = false;
        }),
        catchError(() => {
          this.isPublish = false;
          return of(null);
        })
      ).subscribe()
    );
  }

  goToPrePage() {
    this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'add-resources']);
  }

  goBackToPreviousStep() {
    this.router.navigate([
      '/teacher-dashboard',
      this.classroomId,
      'manual-course-creation',
      'add-resources'
    ]);
  }

  goBack(): void {
    this.router.navigate(['admin-student-platform/admin-courses']);
  }

  getThumbnailSrc(): string {
    const thumb = this.coursePayload.course_thumbnail;
    if (!thumb) return '';
    return thumb instanceof File ? URL.createObjectURL(thumb) : thumb;
  }

  saveCourse() {
    if (this.editCourseForm.invalid) {
      this.editCourseForm.markAllAsTouched();
      this._toastr.error("Please fix the errors before saving");
      return;
    }

    Object.keys(this.editCourseForm.value).forEach(key => {
      const value = this.editCourseForm.get(key)?.value;

      if (value !== null && value !== undefined && value !== '') {

        if (key === 'course_objectives') {
          this.coursePayload.course_objectives = value
            .split('\n')
            .map((v: string) => v.trim())
            .filter((v: string) => v.length > 0);

        } else if (key === 'course_outcomes') {
          this.coursePayload.course_outcomes = value
            .split('\n')
            .map((v: string) => v.trim())
            .filter((v: string) => v.length > 0);

        } else {
          (this.coursePayload as any)[key] = value;
        }
      }
    });

    if (this.previewThumbnail) {
      this.coursePayload.course_thumbnail = this.previewThumbnail;
    }

    this.postUpdateCourse();
    this.isEditing = false;
  }

  cancelEdit() {
    this.isEditing = false;
  }

  postUpdateCourse() {
    this.isLoadingPublish = true;
    this.isLoadingDraft = true;

    const payload: UpdateCourseDataAI = {
      course_id: this.courseId,
      course_title: this.coursePayload.course_title,
      course_code: this.coursePayload.course_code,
      grade_level: this.coursePayload.grade_level,
      rating: this.coursePayload.rating,
      course_description: this.coursePayload.course_description,
      course_duration: this.coursePayload.course_duration,
      total_units_count: this.coursePayload.total_units_count,
      course_outcomes: this.coursePayload.course_outcomes,
      course_objectives: this.coursePayload.course_objectives,
      textbooks: this.coursePayload.textbooks,
      web_references_links: this.coursePayload.web_references_links,
      remove_document: this.removeExistingDocumentFlag
      , remove_thumbnail: this.removeExistingThumbnailFlag
    };

    this.subscription.add(
      this._courseService.postUpdateCourse(
        payload,
        this.courseId,
        this.selectedThumbnailFile ?? null,
        this.selectedDocumentFile ?? null


      ).pipe(
        tap(response => {
          if (response.Success) {
            this.getCourseDetailsById();
            if (this.previewThumbnail) {
              this.coursePayload.course_thumbnail = this.previewThumbnail;
            }
            if (this.selectedDocumentFile === null) {
              this.coursePayload.course_document = null;
            }
            if (this.selectedDocumentFile) {
              this.coursePayload.course_document = this.selectedDocumentFile;
            }


            this._toastr.success("Course updated successfully!");
          } else {
            this._toastr.error(response.Message);
          }
        }),
        finalize(() => {
          this.isLoadingPublish = false;
          this.isLoadingDraft = false;
        })
      ).subscribe()
    );
  }


  onFileSelect(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) this.handleThumbnailFile(file);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave() {
    this.isDragging = false;
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    const file = event.dataTransfer?.files?.[0];
    if (file) this.handleThumbnailFile(file);
  }

  handleThumbnailFile(file: File) {
    const validTypes = ["image/png", "image/jpeg"];
    const maxSize = 5 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      this._toastr.error("Only PNG or JPG images are allowed");
      return;
    }

    if (file.size > maxSize) {
      this._toastr.error("File size must be less than 5MB");
      return;
    }

    this.selectedThumbnailFile = file;
    this.previewThumbnail = URL.createObjectURL(file);
  }

  initializeEditForm() {
    this.editCourseForm = new FormGroup({
      course_title: new FormControl(this.coursePayload.course_title, [
        Validators.maxLength(80),
        Validators.pattern(/^[A-Za-z0-9 .,;&'"()-_]+$/)
      ]),

      course_code: new FormControl(this.coursePayload.course_code, [
        Validators.pattern(/^[A-Za-z0-9_-]+$/)
      ]),

      grade_level: new FormControl(this.coursePayload.grade_level, [Validators.required]),

      rating: new FormControl(this.coursePayload.rating, [
        Validators.min(1),
        Validators.max(5)
      ]),

      course_description: new FormControl(this.coursePayload.course_description, [
        Validators.maxLength(280),
        Validators.pattern(/^[A-Za-z0-9 .,;&'"()-_]+$/)
      ]),

      course_objectives: new FormControl(
        (this.coursePayload.course_objectives || []).join('\n'),
        [Validators.minLength(3)]
      ),
      course_outcomes: new FormControl(
        (this.coursePayload.course_outcomes || []).join('\n'),
        [Validators.minLength(3)]
      )
    });
  }

  editCourse() {
    this.isEditing = true;
    this.initializeEditForm();
  }

  removeSelectedThumbnail() {
    this.selectedThumbnailFile = null;
    this.previewThumbnail = null;
    this.removeExistingThumbnailFlag = true;
    this.coursePayload.course_thumbnail = null as any;
  }

  getThumbnailFileName(): string {
    if (this.selectedThumbnailFile) {
      return this.selectedThumbnailFile.name;
    }

    const thumb = this.coursePayload.course_thumbnail;
    if (typeof thumb === 'string') {
      return thumb.split('/').pop() || '';
    }

    return '';
  }

  remmovexisting() {
    this.previewThumbnail = null;
  }

  initOutcomesForm() {
    this.outcomesForm = new FormGroup({
      course_outcomes: new FormControl(
        (this.coursePayload.course_outcomes || []).join('\n'),
        [Validators.required, Validators.minLength(3)]
      )
    });
  }

  startOutcomesEdit() {
    this.isEditingOutcomes = true;
    this.initOutcomesForm();
  }

  cancelOutcomesEdit() {
    this.isEditingOutcomes = false;
  }

  saveOutcomes() {
    if (this.outcomesForm.invalid) {
      this.outcomesForm.markAllAsTouched();
      this._toastr.error("Please enter at least one valid outcome.");
      return;
    }

    const newOutcomes = this.outcomesForm.get('course_outcomes')?.value;

    this.coursePayload.course_outcomes = newOutcomes
      .split('\n')
      .map((v: string) => v.trim())
      .filter((v: string) => v.length > 0);

    this.postUpdateCourse();

    this.isEditingOutcomes = false;
    // this._toastr.success("Course outcomes updated successfully!");
  }

  startObjectivesEdit() {
    this.isEditingObjectives = true;
    this.initializeEditForm();
  }

  cancelObjectivesEdit() {
    this.isEditingObjectives = false;
  }

  saveObjectives() {
    if (this.editCourseForm.invalid) {
      this.editCourseForm.markAllAsTouched();
      this._toastr.error("Please fix errors before saving");
      return;
    }

    const raw = this.editCourseForm.get('course_objectives')?.value || '';

    this.coursePayload.course_objectives = raw
      .split('\n')
      .map((v: string) => v.trim())
      .filter((v: string) => v.length > 0);

    this.postUpdateCourse();
    this.isEditingObjectives = false;
  }

  initSectionForms() {

    this.textbooksForm = this.fb.group({
      textbooks: this.fb.array(
        this.coursePayload.textbooks.map(tb =>
          this.fb.group({
            title: [tb.title, Validators.required],
            author: [tb.author, Validators.required],
            publisher: [tb.publisher, Validators.required],
            year: [tb.year, [Validators.required, Validators.pattern(/^(?!0000)\d{4}$/),
              noFutureYearValidator]]
          })
        )
      )
    });

    this.webResourcesForm = this.fb.group({
      web_references_links: this.fb.array(
        this.coursePayload.web_references_links.map(link =>
          this.fb.control(
            link,
            [Validators.required, Validators.pattern(/^https?:\/\/.+/)]
          )
        )
      )
    });

    this.documentForm = this.fb.group({
      file: [null]
    });
  }

  saveTextbooksSection() {
    if (this.textbooksForm.invalid) {
      this.textbooksForm.markAllAsTouched();
      return;
    }

    this.coursePayload.textbooks =
      this.textbooksForm.value.textbooks;

    this.postUpdateCourse();
    this.isEditingTextbooks = false;
  }

  saveWebResourcesSection() {
    if (this.webLinksArray.length === 0) {
      this.coursePayload.web_references_links = [];
      this.postUpdateCourse();
      this.isEditingWebResources = false;
      return;
    }

    if (this.webResourcesForm.invalid) {
      this.webResourcesForm.markAllAsTouched();
      return;
    }

    this.coursePayload.web_references_links =
      this.webResourcesForm.value.web_references_links;

    this.postUpdateCourse();
    this.isEditingWebResources = false;
  }


  startEditDocument() {
    this.isEditingCourseDocument = true;

    if (typeof this.coursePayload.course_document === "string") {
      const parts = this.coursePayload.course_document.split("/");
      this.documentFileName = parts[parts.length - 1];
    }
  }

  cancelEditDocument() {
    this.isEditingCourseDocument = false;
    this.selectedDocumentFile = null;
    this.documentFileName = null;
  }

  onDocumentSelect(event: any) {
    const file = event.target.files?.[0];
    if (!file) return;

    const maxSize = 20 * 1024 * 1024;

    if (file.size > maxSize) {
      this._toastr.error("File size must be less than 20MB");
      return;
    }

    this.selectedDocumentFile = file;
    this.documentFileName = file.name;
    this.removeExistingDocumentFlag = false;
  }

  removeDocument() {
    this.selectedDocumentFile = null;
    this.coursePayload.course_document = null;
    this.documentFileName = null;

    this.removeExistingDocumentFlag = true;
  }

  saveDocumentSection() {

    if (this.removeExistingDocumentFlag && !this.selectedDocumentFile) {
      this.coursePayload.course_document = null;
      this.postUpdateCourse();
      this.isEditingCourseDocument = false;
      return;
    }

    if (this.selectedDocumentFile) {
      this.coursePayload.course_document = this.selectedDocumentFile;
    }

    this.postUpdateCourse();
    this.isEditingCourseDocument = false;
  }


  downloadDocument() {
    const doc = this.coursePayload.course_document;

    if (!doc) return;

    if (typeof doc === "string") {
      const link = document.createElement("a");
      link.href = doc;
      link.download = "course-document";
      link.click();
      return;
    }

    const url = URL.createObjectURL(doc);
    const link = document.createElement("a");
    link.href = url;
    link.download = doc.name;
    link.click();

    URL.revokeObjectURL(url);
  }

  getDocumentFileName(): string {
    const doc = this.coursePayload.course_document;

    if (!doc) return '';

    return typeof doc === 'string'
      ? doc.split('/').pop() || ''
      : doc.name;
  }


  get textbooksArray() {
    return this.textbooksForm.get('textbooks') as any;
  }

  get webLinksArray() {
    return this.webResourcesForm.get('web_references_links') as any;
  }

  addWebResource() {
    this.webLinksArray.push(
      this.fb.control('', [
        Validators.required,
        Validators.pattern(/^https?:\/\/.+/)
      ])
    );
  }

  deleteWebResource(index: number) {
    this.webLinksArray.removeAt(index);
  }

  get hasWebLinks(): boolean {
    return this.webLinksArray.length > 0;
  }


  // Create textbook form for adding new
  textbookForm = this.fb.group({
    title: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]],
    author: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]],
    publisher: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]],
    year: [
      '',
      [
        Validators.required,
        Validators.pattern(/^(?!0000)\d{4}$/),
        noFutureYearValidator
      ]
    ]
  });

  addTextbookVisible = false;

  toggleAddTextbook() {
    this.addTextbookVisible = !this.addTextbookVisible;
  }

  addTextbook() {
    if (this.textbookForm.invalid) {
      this.textbookForm.markAllAsTouched();
      this._toastr.error("Please fill valid textbook details");
      return;
    }

    this.textbooksArray.push(
      this.fb.group({
        title: [
          this.textbookForm.value.title,
          [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]
        ],
        author: [
          this.textbookForm.value.author,
          [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]
        ],
        publisher: [
          this.textbookForm.value.publisher,
          [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9 .,;&'-]+$/)]
        ],
        year: [
          '',
          [
            Validators.required,
            Validators.pattern(/^(?!0000)\d{4}$/),
            noFutureYearValidator
          ]
        ]

      })
    );


    this.textbookForm.reset();
    this.addTextbookVisible = false;
  }

  deleteTextbook(i: number) {
    this.textbooksArray.removeAt(i);
  }

  get canSaveTextbooks(): boolean {
    return this.textbooksForm.valid;
  }

  deleteNewSubtopic(u: number, t: number, s: number) {
    this.getSubtopics(u, t).removeAt(s);
  }



  // modules   
  initUnitsForm() {
    this.unitsForm = this.fb.group({
      units: this.fb.array(
        this.coursePayload.units.map(unit =>
          this.fb.group({
            unit_title: [unit.unit_title, Validators.required],
            unit_hours: [
              unit.unit_hours,
              [
                Validators.required,
                Validators.min(1),
                Validators.pattern(/^[0-9]+$/)
              ]
            ],
            expanded: [false],

            topics: this.fb.array(
              unit.topics.map(topic =>
                this.fb.group({
                  topic_title: [topic.topic_title, Validators.required],
                  description: [topic.description],

                  subtopics: this.fb.array(
                    topic.subtopics.map(sub =>
                      this.fb.group({
                        subtopic_title: [sub.subtopic_title, Validators.required],
                        description: [sub.description]
                      })
                    )
                  )
                })
              )
            )
          })
        )
      )
    });

    this.checkUnitsState();
    this.unitsForm.markAsPristine();
    this.unitsForm.valueChanges.subscribe(() => {
      this.checkUnitsState();
    });
  }

  checkUnitsState() {
    const units = this.unitsArray.length;

    if (units === 0) {
      this.canSaveUnits = false;
      return;
    }

    this.canSaveUnits = this.unitsForm.dirty;
  }

  get unitsArray() {
    return this.unitsForm.get('units') as FormArray;
  }

  getTopics(u: number) {
    return this.unitsArray.at(u).get('topics') as FormArray;
  }

  getSubtopics(u: number, t: number) {
    return this.getTopics(u).at(t).get('subtopics') as FormArray;
  }

  toggleUnit(i: number) {
    const expanded = this.unitsArray.at(i).get('expanded')?.value;
    this.unitsArray.at(i).patchValue({ expanded: !expanded });
  }

  addUnit() {
    const courseId = String(this.courseId);

    const newUnitPayload = {
      unit_title: "",
      unit_hours: 0
    };

    this.courseService.postAddUnit(courseId, newUnitPayload).subscribe({
      next: (res: any) => {
        if (res.Success && res.Data?.unit_id) {
          const createdUnit = res.Data;

          this.coursePayload.units.push({
            unit_id: createdUnit.unit_id,
            unit_title: createdUnit.unit_title,
            unit_hours: createdUnit.unit_hours,
            order: createdUnit.order,
            topics: []
          });

          this.unitsArray.push(
            this.fb.group({
              unit_title: [createdUnit.unit_title, Validators.required],
              unit_hours: [
                createdUnit.unit_hours,
                [
                  Validators.required,
                  Validators.min(1),
                  Validators.pattern(/^[0-9]+$/)
                ]
              ],
              expanded: [true],
              topics: this.fb.array([])
            })
          );

          // this._toastr.success("Unit created successfully!");
        } else {
          this._toastr.error(res.Message || "Failed to add unit");
        }
      },
      error: () => {
        this._toastr.error("Error while creating unit");
      }
    });
  }
  deleteUnit(i: number) {

    if (this.unitsArray.length === 1) {
      this._toastr.error("At least one unit must be present");
      return;
    }

    const unit = this.coursePayload.units[i];

    if (!unit?.unit_id) {
      this.unitsArray.removeAt(i);
      return;
    }

    const courseId = String(this.courseId);
    const unitId = String(unit.unit_id);

    this.courseService.deleteUnitById(courseId, unitId).subscribe({
      next: res => {
        if (res.Success) {
          this._toastr.success("Unit deleted");
          this.unitsArray.removeAt(i);
          this.loadCourseData();
        } else {
          this._toastr.error(res.Message || "Failed to delete unit");
        }
      },
      error: () => this._toastr.error("Failed to delete unit")
    });
  }

  preventZeroAndNegative(event: any) {
    const value = Number(event.target.value);
    if (value < 1) {
      event.target.value = '';
    }
  }


  addTopic(u: number) {
    const unit = this.coursePayload.units[u];

    if (!unit.unit_id) {
      this._toastr.error("Please save unit before adding topics");
      return;
    }

    const courseId = String(this.courseId);
    const unitId = String(unit.unit_id);

    const payload = {
      course_id: courseId,
      unit_id: unitId,
      topic_title: "",
      description: "",
      order: unit.topics.length + 1,
      subtopics: []
    };

    this.courseService.postAddtopic(courseId, unitId, payload).subscribe({
      next: (res: any) => {
        if (res.Success && res.Data?.topic_id) {
          unit.topics.push({
            topic_id: res.Data.topic_id,
            topic_title: payload.topic_title,
            description: "",
            subtopics: []
          });

          this.getTopics(u).push(
            this.fb.group({
              topic_title: [payload.topic_title, Validators.required],
              description: [''],
              subtopics: this.fb.array([]),
              topic_id: res.Data.topic_id
            })
          );

        } else {
          this._toastr.error(res.Message || "Failed to add topic");
        }
      },
      error: () => {
        this._toastr.error("Error adding topic");
      }
    });
  }


  deleteTopic(u: number, t: number) {
    const topics = this.getTopics(u);

    if (topics.length === 1) {
      this._toastr.error("Each unit must have at least one topic");
      return;
    }

    const unit = this.coursePayload.units[u];
    const topic = unit?.topics[t];

    if (!topic?.topic_id) {
      topics.removeAt(t);
      return;
    }

    const courseId = String(this.courseId);
    const unitId = String(unit.unit_id);
    const topicId = String(topic.topic_id);

    this.courseService.deleteTopicById(courseId, unitId, topicId).subscribe({
      next: res => {
        if (res.Success) {
          this._toastr.success("Topic deleted");
          topics.removeAt(t);
          this.loadCourseData();
        } else {
          this._toastr.error(res.Message || "Failed to delete topic");
        }
      },
      error: () => this._toastr.error("Delete topic failed")
    });
  }

  addSubtopic(u: number, t: number) {
    this.getSubtopics(u, t).push(
      this.fb.group({
        subtopic_title: ['', Validators.required],
        description: ['']
      })
    );
  }

  cancelUnitsEdit() {
    this.isEditingUnits = false;
    this.initUnitsForm();
  }

  saveUnitsSection() {
    if (this.unitsForm.invalid) {
      this.unitsForm.markAllAsTouched();
      this._toastr.error("Check whether all the data is valid or not.");
      return;
    }

    for (let u = 0; u < this.unitsArray.length; u++) {
      const topics = this.getTopics(u).controls;

      if (topics.length === 0) {
        this._toastr.error(`Unit ${u + 1} must have at least 1 topic`);
        return;
      }
    }

    const updatedUnits = this.unitsForm.value.units;
    const courseId = String(this.courseId);
    const apiCalls: any[] = [];
    updatedUnits.forEach((unit: any, u: number) => {

      const existingUnit = this.coursePayload.units[u];
      const hasUnitId = !!existingUnit?.unit_id;

      if (!hasUnitId) {
        const payload = {
          unit_title: unit.unit_title,
          unit_hours: Number(unit.unit_hours),
          order: u + 1
        };
 
        apiCalls.push(
          this.courseService.postAddUnit(courseId, payload).pipe(
            tap((res: any) => {
              if (res.Success && res.Data?.unit_id) {
                this.coursePayload.units[u].unit_id = res.Data.unit_id;
              }
            })
          )
        );

        return;
      }

      const unitId = String(existingUnit.unit_id);
      const updateUnitPayload = {
        unit_id: unitId,
        course_id: courseId,
        unit_title: unit.unit_title,
        unit_hours: Number(unit.unit_hours)
      };
      apiCalls.push(
        this.courseService.postUpdateUnitById(courseId, unitId, updateUnitPayload)
      );
      unit.topics.forEach((topic: any, t: number) => {

        const existingTopic = existingUnit.topics[t];
        if (!existingTopic?.topic_id) return;

        const topicPayload = {
          topic_title: topic.topic_title,
          description: topic.description ?? "",
          course_id: courseId,
          subtopics: (topic.subtopics ?? []).map((sub: any) => ({
            subtopic_title: sub.subtopic_title || "",
            description: sub.description || "",
            reference_links: sub.reference_links ?? []
          }))
        };

        apiCalls.push(
          this.courseService.postUpdateTopicById(
            courseId,
            unitId,
            existingTopic.topic_id,
            String(t + 1),
            topicPayload
          )
        );
      });

    });

    forkJoin(apiCalls).subscribe({
      next: () => {
        this._toastr.success("Modules & Lessons updated!");
        this.isEditingUnits = false;
        this.loadCourseData();
      },
      error: () => {
        this._toastr.error("Failed to update modules");
      }
    });
  }

  quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      ['clean']
    ]
  };

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}